import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class CollegePredictorService {
  constructor(private http: HttpService) { }

  getBranches(exam){
    return this.http.get(`getExamBranches`, false, {exam}, true, false,environment.serverURLv3);
  }
  getExamCategory(exam){
    return this.http.get(`getExamCategory`, false, {exam}, true, false,environment.serverURLv3);
  }
  
  getQuotaCategory(exam){
    return this.http.get(`getQuotaCategory`, false,{exam}, true, false,environment.serverURLv3);
  }

  getColleges(payload,examType){
    return this.http.post(`getCollege?exam=${examType}`, false,payload, true,true, false,environment.serverURLv3);
  }
}

